module.exports = __webpack_public_path__ + "a26d4c2a6f88424ba56fdbc884ede068.svg";